const target = new Date("2026-08-25T18:00:00+12:00").getTime();
function tick(){
const now = Date.now();
let diff = Math.max(0, target - now);
const d = Math.floor(diff / 86400000);
const h = Math.floor((diff % 86400000) / 3600000);
const m = Math.floor((diff % 3600000) / 60000);
const s = Math.floor((diff % 60000) / 1000);
document.getElementById('cd-days').textContent = String(d).padStart(2,'0');
document.getElementById('cd-hours').textContent = String(h).padStart(2,'0');
document.getElementById('cd-mins').textContent = String(m).padStart(2,'0');
document.getElementById('cd-secs').textContent = String(s).padStart(2,'0');
}
tick();
setInterval(tick, 1000);
const ANCHOR = new Date(2026,7,25);
const WEEK_TYPES = [
{name:'The Shop', sub:'Pack Groups', color:'blue', coached:false},
{name:'Hagley Park', sub:'Coached Intervals', color:'pink', coached:true},
{name:'Princess Margaret', sub:'Coached Hill Reps', color:'blue', coached:true}
];
const TRAINING_PLAN = [
{week:1, type:'shop',
tueISO:'2026-08-25', thuISO:'2026-08-27', friISO:'2026-08-28', longISO:'2026-08-30', raceISO:null,
tueTitle:'Social Pack Run', tueDetail:'30 minutes, easy conversational pace. · All groups leave together.',
thuTitle:'Rest', thuDetail:'No Thursday session this week — Friday\'s the quality day.',
friTitle:'Progression Tempo', friDetail:'Warm-up: 10min easy. · Progression tempo: 3 × 5min, easy → moderate → tempo pace (2min jog between). · Warm-down: 10min easy.',
longKm:8, longLabel:'Sun 30 Aug', longNote:null,
cutback:false, taper:false,
peak:false, race:false,
tempo:true, progression:false},
{week:2, type:'hagley',
tueISO:'2026-09-01', thuISO:'2026-09-03', friISO:'2026-09-04', longISO:'2026-09-06', raceISO:null,
tueTitle:'Ladder / Pyramid — Var. 1', tueDetail:'Warm-up + drills first. · Grp 1–2 (20min): 2-3-4-5-6 · Grp 3–4 (14min): 2-3-4-3-2',
thuTitle:'Easy Run', thuDetail:'40 minutes, easy pace',
friTitle:'Rest (Gym Day)', friDetail:'Suggested strength session.',
longKm:12, longLabel:'Sun 6 Sep', longNote:'Final 10–15min: build steadily to goal race effort.',
cutback:false, taper:false,
peak:false, race:false,
tempo:false, progression:true},
{week:3, type:'pm',
tueISO:'2026-09-08', thuISO:'2026-09-10', friISO:'2026-09-11', longISO:'2026-09-13', raceISO:null,
tueTitle:'Hill Reps — Var. 1', tueDetail:'Warm-up + drills first. · Grp 1–2 (16min): 2-5-2-5-2 · Grp 3–4 (12min): 2-3-2-3-2 · Jog down = recovery.',
thuTitle:'Rest', thuDetail:'No Thursday session this week — Friday\'s the quality day.',
friTitle:'Progression Tempo', friDetail:'Warm-up: 10min easy. · Progression tempo: 3 × 6min, easy → moderate → tempo pace (2min jog between). · Warm-down: 10min easy.',
longKm:15, longLabel:'Sun 13 Sep', longNote:null,
cutback:false, taper:false,
peak:false, race:false,
tempo:true, progression:false},
{week:4, type:'shop',
tueISO:'2026-09-15', thuISO:'2026-09-17', friISO:'2026-09-18', longISO:'2026-09-20', raceISO:null,
tueTitle:'Social Pack Run', tueDetail:'40 minutes, easy conversational pace.',
thuTitle:'Interval Session (suggested)', thuDetail:'8 × 2min @ 5K effort · 90sec jog recovery',
friTitle:'Rest (Gym Day)', friDetail:'Suggested strength session.',
longKm:10, longLabel:'Sun 20 Sep', longNote:null,
cutback:true, taper:false,
peak:false, race:false,
tempo:false, progression:false},
{week:5, type:'hagley',
tueISO:'2026-09-22', thuISO:'2026-09-24', friISO:'2026-09-25', longISO:'2026-09-27', raceISO:null,
tueTitle:'Ladder / Pyramid — Var. 2', tueDetail:'Warm-up + drills first. · Grp 1–2 (20min): 6-5-4-3-2 · Grp 3–4 (14min): 2-3-4-5',
thuTitle:'Easy Run', thuDetail:'45 minutes, easy pace',
friTitle:'Rest (Gym Day)', friDetail:'Suggested strength session.',
longKm:17, longLabel:'Sun 27 Sep', longNote:'Final 10–15min: build steadily to goal race effort.',
cutback:false, taper:false,
peak:false, race:false,
tempo:false, progression:true},
{week:6, type:'pm',
tueISO:'2026-09-29', thuISO:'2026-10-01', friISO:'2026-10-02', longISO:'2026-10-04', raceISO:null,
tueTitle:'Hill Reps — Var. 2', tueDetail:'Warm-up + drills first. · Grp 1–2 (16min): 4-2-4-2-4 · Grp 3–4 (12min): 3-2-3-2-2 · Jog down = recovery.',
thuTitle:'Rest', thuDetail:'No Thursday session this week — Friday\'s the quality day.',
friTitle:'Progression Tempo', friDetail:'Warm-up: 10–15min easy. · Progression tempo: 4 × 5min, building each rep toward tempo/threshold (90sec jog between). · Warm-down: 10min easy.',
longKm:20, longLabel:'Sun 4 Oct', longNote:null,
cutback:false, taper:false,
peak:false, race:false,
tempo:true, progression:false},
{week:7, type:'shop',
tueISO:'2026-10-06', thuISO:'2026-10-08', friISO:'2026-10-09', longISO:'2026-10-11', raceISO:null,
tueTitle:'Social Pack Run', tueDetail:'50 minutes, easy conversational pace.',
thuTitle:'Interval Session (suggested)', thuDetail:'5 × 3min @ 10K–5K effort · 90sec jog recovery',
friTitle:'Rest (Gym Day)', friDetail:'Suggested strength session.',
longKm:23, longLabel:'Sun 11 Oct', longNote:'Final 10–15min: build steadily to goal race effort.',
cutback:false, taper:false,
peak:false, race:false,
tempo:false, progression:true},
{week:8, type:'hagley',
tueISO:'2026-10-13', thuISO:'2026-10-15', friISO:'2026-10-16', longISO:'2026-10-18', raceISO:null,
tueTitle:'Ladder / Pyramid — Var. 3', tueDetail:'Warm-up + drills first. · Grp 1–2 (20min): 2-3-4-5-4-2 · Grp 3–4 (14min): 5-4-3-2',
thuTitle:'Easy Run', thuDetail:'50 minutes, easy pace',
friTitle:'Rest (Gym Day)', friDetail:'Suggested strength session.',
longKm:14, longLabel:'Sun 18 Oct', longNote:null,
cutback:true, taper:false,
peak:false, race:false,
tempo:false, progression:false},
{week:9, type:'pm',
tueISO:'2026-10-20', thuISO:'2026-10-22', friISO:'2026-10-23', longISO:'2026-10-25', raceISO:null,
tueTitle:'Hill Reps — Var. 3', tueDetail:'Warm-up + drills first. · Grp 1–2 (16min): 3-5-3-5 · Grp 3–4 (12min): 2-4-2-4 · Jog down = recovery.',
thuTitle:'Rest', thuDetail:'No Thursday session this week — Friday\'s the quality day.',
friTitle:'Progression Tempo', friDetail:'Warm-up: 15min easy. · Progression tempo: 4 × 6min, building to marathon-pace-plus by the final rep (90sec jog between). · Warm-down: 10min easy.',
longKm:27, longLabel:'Sun 25 Oct', longNote:null,
cutback:false, taper:false,
peak:false, race:false,
tempo:true, progression:false},
{week:10, type:'shop',
tueISO:'2026-10-27', thuISO:'2026-10-29', friISO:'2026-10-30', longISO:'2026-11-01', raceISO:null,
tueTitle:'Social Pack Run', tueDetail:'60 minutes, easy conversational pace.',
thuTitle:'Interval Session (suggested)', thuDetail:'6 × 3min @ threshold effort · 90sec jog recovery',
friTitle:'Rest (Gym Day)', friDetail:'Suggested strength session.',
longKm:30, longLabel:'Sun 1 Nov', longNote:'Final 10–15min: build steadily to goal race effort.',
cutback:false, taper:false,
peak:true, race:false,
tempo:false, progression:true},
{week:11, type:'hagley',
tueISO:'2026-11-03', thuISO:'2026-11-05', friISO:'2026-11-06', longISO:'2026-11-08', raceISO:null,
tueTitle:'Ladder / Pyramid — Var. 4', tueDetail:'Warm-up + drills first. · Grp 1–2 (20min): 2-4-5-4-3-2 · Grp 3–4 (14min): 1-3-4-3-2-1',
thuTitle:'Rest', thuDetail:'No Thursday session this week — Friday\'s the quality day.',
friTitle:'Progression Tempo', friDetail:'Warm-up: 10min easy. · Progression tempo: 2 × 6min, easy building to tempo — taper week, kept short. · Warm-down: 10min easy.',
longKm:18, longLabel:'Sun 8 Nov', longNote:null,
cutback:false, taper:true,
peak:false, race:false,
tempo:true, progression:false},
{week:12, type:'race',
tueISO:'2026-11-10', thuISO:'2026-11-12', friISO:'2026-11-13', longISO:null, raceISO:'2026-11-14',
tueTitle:'Shakeout (adjusted from Hill Reps)', tueDetail:'25–30min easy + 4 × 20sec strides. · Full hill reps skipped — too close to race day.',
thuTitle:'Shakeout', thuDetail:'20–25min easy + strides',
friTitle:'Rest', friDetail:'Day before the race — legs up, feet up.',
longKm:null, longLabel:'Sat 14 Nov — QUEENSTOWN MARATHON', longNote:null,
cutback:false, taper:false,
peak:false, race:true,
tempo:false, progression:false}
];
function weekTypeFor(date){
const diffDays = Math.round((stripTime(date) - stripTime(ANCHOR)) / 86400000);
const diffWeeks = Math.floor(diffDays / 7);
let idx = diffWeeks % 3;
if(idx < 0) idx += 3;
return WEEK_TYPES[idx];
}
function stripTime(d){ return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }
function isoKey(d){ return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0'); }
const WHERE_BY_TYPE = {
shop: 'Colombo St · 6:00PM · Free',
hagley: 'Hagley Park · 6:00PM · Free',
pm: 'Cashmere Rd · 6:00PM · Free'
};
const planByTue = {}, planByThu = {}, planByFri = {}, planByLong = {}, planByRace = {};
TRAINING_PLAN.forEach(p=>{
planByTue[p.tueISO] = p;
planByThu[p.thuISO] = p;
if(p.friTitle && p.friTitle !== 'Rest (Gym Day)') planByFri[p.friISO] = p;
if(p.longISO) planByLong[p.longISO] = p;
if(p.raceISO) planByRace[p.raceISO] = p;
});
let current = new Date(2026,7,1);
let selected = new Date(ANCHOR);
const monthLabelEl = document.getElementById('cal-month-label');
const gridEl = document.getElementById('cal-grid');
function renderCalendar(){
const year = current.getFullYear(), month = current.getMonth();
monthLabelEl.textContent = current.toLocaleString('en-NZ',{month:'long', year:'numeric'});
const firstWeekday = new Date(year, month, 1).getDay();
const daysInMonth = new Date(year, month+1, 0).getDate();
let html = '';
for(let i=0;i<firstWeekday;i++){ html += '<div class="cal-cell empty"></div>'; }
for(let day=1; day<=daysInMonth; day++){
const d = new Date(year, month, day);
const dow = d.getDay();
const key = isoKey(d);
let inner = '<span class="cal-daynum">'+day+'</span>';
let cls = 'cal-cell';
if(planByRace[key]){
cls += ' clickable';
inner += '<span class="cal-tag brand">Race Day</span>';
} else if(dow === 2){
cls += ' clickable';
const p = planByTue[key];
if(p){
const wt = WEEK_TYPES.find(w=> (p.type==='shop'&&w.name==='The Shop') || (p.type==='hagley'&&w.name==='Hagley Park') || (p.type==='pm'&&w.name==='Princess Margaret'));
const shortLabel = p.type==='shop' ? 'Shop' : (p.type==='hagley' ? 'Hagley' : 'Hill Reps');
inner += '<span class="cal-tag '+(wt?wt.color:'blue')+'">Wk '+p.week+' · '+shortLabel+'</span>';
} else {
const wt = weekTypeFor(d);
inner += '<span class="cal-tag '+wt.color+'">'+wt.name+'</span>';
}
} else if(dow === 4 && planByThu[key]){
cls += ' clickable';
const shortThu = planByThu[key].thuTitle.startsWith('Interval') ? 'Interval' : (planByThu[key].thuTitle.startsWith('Shakeout') ? 'Shakeout' : (planByThu[key].thuTitle==='Rest' ? 'Rest' : 'Easy Run'));
inner += '<span class="cal-tag pink">'+shortThu+'</span>';
} else if(dow === 5 && planByFri[key]){
cls += ' clickable';
inner += '<span class="cal-tag blue">Tempo</span>';
} else if(dow === 0 && planByLong[key]){
cls += ' clickable';
inner += '<span class="cal-tag sun">'+planByLong[key].longKm+'km Long Run</span>';
}
html += '<div class="'+cls+'" data-date="'+d.toISOString()+'">'+inner+'</div>';
}
gridEl.innerHTML = html;
gridEl.querySelectorAll('.cal-cell.clickable').forEach(cell=>{
cell.addEventListener('click', ()=>{
selected = new Date(cell.getAttribute('data-date'));
renderPreview();
});
});
}
function renderPreview(){
const d = selected;
const key = isoKey(d);
const dateStr = d.toLocaleDateString('en-NZ',{weekday:'short', day:'numeric', month:'short'});
const top = document.getElementById('st-top');
const label = document.getElementById('st-label');
const headline = document.getElementById('st-headline');
const tags = document.getElementById('st-tags');
const dateEl = document.getElementById('st-date');
const whereEl = document.getElementById('st-where');
tags.innerHTML = '';
dateEl.textContent = dateStr;
if(planByRace[key]){
const p = planByRace[key];
top.textContent = 'FRRC — RACE DAY';
label.textContent = 'Week ' + p.week;
headline.textContent = 'Queenstown Marathon';
tags.innerHTML = '<span style="background:var(--pink); color:var(--ink);">This is it</span>';
whereEl.textContent = 'Queenstown, NZ';
} else if(planByTue[key]){
const p = planByTue[key];
top.textContent = 'FRRC — TUESDAY 6PM';
label.textContent = 'Week ' + p.week;
headline.textContent = p.tueTitle;
let tagHtml = '<span style="background:var(--blue); color:var(--ink);">'+p.tueDetail.split(' · ')[0]+'</span>';
if(p.cutback) tagHtml += '<span style="background:var(--paper); color:var(--ink);">Cutback Week</span>';
if(p.taper) tagHtml += '<span style="background:var(--paper); color:var(--ink);">Taper</span>';
tags.innerHTML = tagHtml;
whereEl.textContent = WHERE_BY_TYPE[p.type] || WHERE_BY_TYPE.shop;
} else if(planByThu[key]){
const p = planByThu[key];
top.textContent = 'FRRC — THURSDAY';
label.textContent = 'Week ' + p.week;
headline.textContent = p.thuTitle;
tags.innerHTML = '<span style="background:var(--pink); color:var(--ink);">'+p.thuDetail+'</span>';
whereEl.textContent = 'Self-guided';
} else if(planByFri[key]){
const p = planByFri[key];
top.textContent = 'FRRC — FRIDAY';
label.textContent = 'Week ' + p.week;
headline.textContent = p.friTitle;
tags.innerHTML = '<span style="background:var(--blue); color:var(--ink);">'+p.friDetail.split(' · ')[1]+'</span>';
whereEl.textContent = 'Self-guided';
} else if(planByLong[key]){
const p = planByLong[key];
top.textContent = 'FRRC — LONG RUN';
label.textContent = 'Week ' + p.week;
headline.textContent = p.longKm + 'km';
tags.innerHTML = '<span style="background:var(--blue); color:var(--ink);">Weekend Long Run</span>' + (p.longNote ? '<span style="background:var(--pink); color:var(--ink);">Progression Finish</span>' : '');
whereEl.textContent = 'Self-guided';
} else {
const wt = weekTypeFor(d);
top.textContent = 'FRRC — TUESDAY 6PM';
label.textContent = 'Week ' + (WEEK_TYPES.indexOf(wt)+1);
headline.textContent = wt.name;
tags.innerHTML = '<span style="background:var('+'--'+wt.color+'); color:var(--ink);">'+wt.sub+'</span>';
const t = wt.name === 'The Shop' ? 'shop' : (wt.name === 'Hagley Park' ? 'hagley' : 'pm');
whereEl.textContent = WHERE_BY_TYPE[t];
}
}
document.getElementById('cal-prev').addEventListener('click', ()=>{
current = new Date(current.getFullYear(), current.getMonth()-1, 1);
renderCalendar();
});
document.getElementById('cal-next').addEventListener('click', ()=>{
current = new Date(current.getFullYear(), current.getMonth()+1, 1);
renderCalendar();
});
renderCalendar();
renderPreview();